import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index.component';
import { Routes, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module';
import { MatListModule } from '@angular/material/list';
import {MatTabLink, MatTabNav} from "@angular/material/tabs";

const routes: Routes = [
  { path: '**', component: IndexComponent}
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        SharedModule.forRoot(),
        MatCardModule, MatButtonModule, MatIconModule, MatListModule, MatTabLink, MatTabNav
    ],
  declarations: [IndexComponent]
})
export class IndexModule { }
